import { render, staticRenderFns } from "./Detalle.vue?vue&type=template&id=0d86fca2&scoped=true"
import script from "./Detalle.vue?vue&type=script&lang=js"
export * from "./Detalle.vue?vue&type=script&lang=js"
import style0 from "./Detalle.vue?vue&type=style&index=0&id=0d86fca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d86fca2",
  null
  
)

export default component.exports